import { Grid, Typography } from '@mui/material';
import clsx from 'clsx';

import { TextLinkComponent } from 'components/_basic/TextLinkComponent';

import { IFormTableExpectedProps } from './types';

import styles from './FormTableExpected.module.scss';

export const FormTableExpected: React.FC<IFormTableExpectedProps> = ({
  rowHeader,
  onHeaderClick,
  firstColumnWidth,
  columns,
}) => {
  return (
    <Grid container display="flex" alignItems="center" gap={1}>
      <Grid item sx={{ width: 20 }}></Grid>
      <Grid item sx={{ width: firstColumnWidth }}>
        {rowHeader && (
          <Typography
            variant="subtitle2"
            component={TextLinkComponent}
            className={clsx(styles.title)}
            onClick={onHeaderClick}
          >
            {rowHeader}
          </Typography>
        )}
      </Grid>
      {columns.map((value, index) => (
        <Grid item xs key={index} className={value.includes('%') ? styles.percentagePadding : ''}>
          <Typography variant="subtitle2">{value}</Typography>
        </Grid>
      ))}
    </Grid>
  );
};
